<template>
  <div class="hometest">
    <div class="homeBox" v-if="$store.state.webNavigator == 'pc'">
      <div class="">
        <TopNavigation/>
        <div class="">
          <div class=" testBar">
            <div>
              <div class="swiper-container banner home-top home-rol">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide"
                    v-for="(item, index) in rolllist"
                    :key="index"
                  >
                    <img class="home-top-img" :src="item" alt="" title=""/>
                  </div>
                </div>
                <div class="swiper-button-prev"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-pagination"></div>
              </div>
              <div class="shubiao flexCenter">
                <img
                  class="shubiao-icon"
                  title=""
                  :src="src1"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class=" testBar testButton">
            <homeTame :loadType="loadType"/>
          </div>
          <div class=" testBar">
            <homeVideo :loadType="loadType2" @playVideo="getvideo"/>
          </div>
          <div class=" testBar">
            <homeShop :loadType="loadType3"/>
          </div>
          <div class=" testBar">
            <homeDoctorvideo :loadType="loadType4" @playVideo2="getvideo"/>
          </div>
          <div class=" testBar">
            <homeExpert v-if="$store.state.home.getDotor.length" :loadType="loadType5"/>
          </div>
          <div class=" testBar">
            <homeNews :loadType="loadType6"/>
          </div>
          <div class=" testBar150">
            <FooterNavigation/>
          </div>
        </div>
      </div>
      <div>
        <playVideo
          v-show="playVideoType"
          @funcVideo="downvideo"
          :videoPlay="videoPlay"
          :videoTlt="videoTlt"
        />
      </div>
    </div>
    <div v-else class="phone-page">
      <div>
        <TopNavigation/>
      </div>
      <div class="page-content">
        <div class="swiper-container bannerPhone home-top">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in rolllistPhone"
              :key="index"
            >
              <img :src="item" alt="" title="" :style="{width: 100+'%',height: 800*(100/750)+'vw'}"/>
            </div>
          </div>
          <div id="swiper-paginationHome" class="swiper-pagination"></div>
        </div>
        <div class="phone-homeMain">
          <div>
            <homeTame :loadType="loadType"/>
          </div>
          <div>
            <homeVideo :loadType="loadType2" @playVideo="getvideo"/>
          </div>
          <div>
            <homeShop :loadType="loadType3"/>
          </div>
          <div>
            <homeDoctorvideo :loadType="loadType4" @playVideo2="getvideo"/>
          </div>
          <div>
            <homeExpert v-if="$store.state.home.getDotor.length" :loadType="loadType5"/>
          </div>
          <div>
            <homeNews :loadType="loadType6"/>
          </div>

        </div>
      </div>
      <div>
        <FooterNavigation/>
      </div>
      <div>
        <playVideo
          v-show="playVideoType"
          @funcVideo="downvideo"
          :videoPlay="videoPlay"
          :videoTlt="videoTlt"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {$get, $post, } from '@/others/ajax';
import config from '@/others/interface';
import home from '../../store/home/home';
import TopNavigation from '../../components/TopNavigation/TopNavigation';
import FooterNavigation from '../../components/FooterNavigation/FooterNavigation';
import playVideo from '../../components/playVideo/playVideo';
import homeTame from './comPonents/homeTeam/homeTeam';
import homeVideo from './comPonents/homeVideo/homeVideo';
import homeShop from './comPonents/homeShop/homeShop';
import homeDoctorvideo from './comPonents/homeDoctorvideo/homeDoctorvideo';
import homeExpert from './comPonents/homeExpert/homeExpert';
import homeNews from './comPonents/homeNews/homeNews';
import {myFun, } from '../../plug/modifyImagePath';

export default {
  name: 'hometest',
  components: {
    TopNavigation,
    FooterNavigation,
    playVideo,
    homeTame,
    homeVideo,
    homeShop,
    homeDoctorvideo,
    homeExpert,
    homeNews,
  },
  title () {
    return {
      title: '脂玫乐(谷医坊)-专注健康瘦身|减脂|减肥|减肥方法|减肥服务',
      keywords:
          '健康瘦身，减脂，减肥，减肥方法，减肥服务',
      description: '脂玫乐，专业健康减肥瘦身网，提供个性化“体质管理+营养管理+作息管理”三位一体的健康瘦身方案和服务。',
    };
  },
  data: () => ({
    rolllist: myFun([
      'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/top1.png',
      // 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/top2.png',
      // 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/top3.png',
      // 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/RotationChart/top4.png',
    ]),
    rolllistPhone: myFun([
      'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/topNav1.jpg',
      'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/topNav2.jpg',
      // 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/topNav3.jpg',
      'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/v1.1.1/phone/RotationChart/topNav4.jpg',
    ]),
    reg: /<\/?.+?\/?>/g,
    src1: myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/pc_home/shubiao.png'),
    imgUrl: 'https://jusexcx.oss-cn-hangzhou.aliyuncs.com/',
    // 视频播放
    playVideoType: false,
    videoPlay: '',
    videoTlt: '',
    loadType: false,
    loadType2: false,
    loadType3: false,
    loadType4: false,
    loadType5: false,
    loadType6: false,
  }),
  watch: {},

  methods: {
    // initSwiper () {
    //   this.$store.dispatch('getSwiper', () => {
    //     // 广告轮播图
    //     let banner6 = new Swiper('.banner6', {
    //       direction: 'vertical',
    //       slidesPerView: 'auto',
    //       spaceBetween: 30,
    //       mousewheel: {
    //         releaseOnEdges: true,
    //       },
    //       speed: 1000,
    //     });
    //     $('#toTop').click(function () {
    //       banner6.slideTo(0, 1000, false); // 切换到第一个slide，速度为1秒
    //     });
    //   });
    // },
    initSwiper6 () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.banner = new Swiper('.banner', {
          loop: true,
          autoHeight: true,
          autoplay: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
          },
        });
      });
    },
    initSwiperPhone () {
      this.$store.dispatch('getSwiper', () => {
        // 广告轮播图
        this.bannerPhone = new Swiper('.bannerPhone', {
          loop: true,
          autoHeight: true,
          // autoplay: true,
          pagination: {
            el: '#swiper-paginationHome',
          },
        });
      });
    },
    getvideo (videoPlay, videoTlt) {
      if (this.videoPlay != '') {
        this.videoPlay = '';
        this.videoTlt = '';
      }
      this.videoPlay = videoPlay;
      this.videoTlt = videoTlt;
      this.playVideoType = true;
    },
    downvideo (data) {
      this.playVideoType = data;
    },
    gotoPath2 (item) {
      this.$router.push({
        path:
            '/brandNewsInfo/' +
            item.articleid +
            '/' +
            item.articleKeyWord +
            '/' +
            item.articleid +
            '.html',
      });
    },
  },
  async asyncData ({store, app, }) {
    store.registerModule('home', home);
    let res = await $get(config.zmlgw + '/web/getDotor?pageSize=100'); // 轮播图列表接口
    let article = await $get(
      config.zmlgw + '/web/getHomeList?code=A7&pageSize=8'
    ); // 文章列表接口
    if (res.code == 200) {
      app.$set(store.state.home, 'getDotor', res.data);
    }
    if (article.code == 200) {
      app.$set(store.state.home, 'articlelist', article.data);
    }
  },
  async mounted () {
    this.$store.state.webNavigator == 'pc' ? this.initSwiper6() : this.initSwiperPhone();
  },
};
</script>
<style scoped lang="less">
  @media screen and (max-width: 800px) {
    @import url("./hometestPhone.less");
  }

  @media screen and (min-width: 800px) {
    @import url("./hometest.less");
  }
</style>
<style lang="less">
  @import url('../../../static/css/fontSize.less');
  @media screen and (max-width: 800px) {
    .img-ssr-vueshowsrc {
      width: 100%;
    }

    .swiper-button-prev,
    .swiper-button-next {
      margin: 0 23 * @width1;
    }

    .swiper-button-minnext {
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/next.png") no-repeat;
    }

    .home-rol:hover .swiper-button-prev,
    .home-rol:hover .swiper-button-next {
      display: inline-block;
    }

    .swiper-button-prev {
      width: 35 * @width1;
      height: 35 * @width1;
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/prev.png") no-repeat;
      background-size: cover;
    }

    .swiper-button-next {
      width: 44 * @width1;
      height: 44 * @width1;
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/next.png") no-repeat;
      background-size: cover;
    }

    //分页器
    #swiper-paginationHome {
      bottom: 33*@width1;
      left: 0;
      width: 100%;
    }

    #swiper-paginationHome > .swiper-pagination-bullet {
      width: 34 * @width1;
      height: 5 * @width1;
      background: #CCCCCC;
      border-radius: 2 * @width1;
    }

    #swiper-paginationHome > .swiper-pagination-bullet-active {
      background: #00CDA2;
    }
  }
  @media screen and (min-width: 800px) {
    .img-ssr-vueshowsrc {
      width: 100%;
    }

    .swiper-button-prev,
    .swiper-button-next {
      display: none;
      width: 70px;
      height: 70px;
      margin: 0 40px;
    }

    .swiper-button-minnext {
      width: 15px;
      height: 15px;
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/next.png") no-repeat;
    }

    .home-rol:hover .swiper-button-prev,
    .home-rol:hover .swiper-button-next {
      display: inline-block;
    }

    .swiper-button-prev {
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/prev.png") no-repeat;
    }

    .swiper-button-next {
      background: url("https://jusewebapp.zmelo.com/zml-gw/pc_home/next.png") no-repeat;
    }

    .swiper-pagination {
      margin-bottom: 29px;
    }

    .swiper-pagination-bullet {
      width: 45px;
      height: 10px;
      background: rgba(176, 176, 176, 1);
      border-radius: 5px;
    }

    .swiper-pagination-bullet-active {
      background: rgba(0, 167, 60, 1);
    }
  }
</style>



// WEBPACK FOOTER //
// hometest.vue